import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import { AutoCompleteItemValue } from '../../components/shared/nextgen/selector/types';
import {TimeSheetGroupType, TimeSheetItem, TimeSheetItemStatus} from './types';
import {Lx} from '../../i18n/consts';

interface State {
    data: Array<TimeSheetItem>
    /* Kept in the store so the chosen view survives navigating to a form, like the filters do. */
    groupBy: TimeSheetGroupType
}

export const initialStatuses: AutoCompleteItemValue[] = [
    { id: 0, name: Lx.Schedule.REGULAR_HOURS, originalId: TimeSheetItemStatus.NORMAL },
    { id: 1, name: Lx.Schedule.APPROVED_HOURS, originalId: TimeSheetItemStatus.APPROVED },
    { id: 2, name: Lx.Schedule.BILLABLE_HOURS, originalId: TimeSheetItemStatus.BILLABLE },
]

const initialState: State = {
    data: [],
    groupBy: TimeSheetGroupType.EMPLOYEEVIEW
}

const timeSheetSlice = createSlice({
    name: 'timesheet',
    initialState,
    reducers: {
        clearData: (state) => {
            state.data = []
        },
        setData: (state, action: PayloadAction<Array<TimeSheetItem>>) => {
            state.data = action.payload
        },
        setGroupBy: (state, action: PayloadAction<TimeSheetGroupType>) => {
            state.groupBy = action.payload
        }
    }
})

export const { clearData, setData, setGroupBy } = timeSheetSlice.actions;

export default timeSheetSlice.reducer;
